import React, { useEffect, useState } from 'react';
import AboutDataEN from './AboutData';
import AboutDataFr from './AboutDataFr';

import { makeStyles } from '@material-ui/core/styles';
// import AboutText from './Aboutsectiondata';
// import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
//import TeamMember from './TeamMember';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import FlipCameraAndroidIcon from '@material-ui/icons/FlipCameraAndroid';
import useWindowDimensions from './WindowDimensions';
import 'swiper/swiper.scss';
import 'swiper/modules/pagination/pagination.scss';
import './AboutSection.css';
import { Container, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  aboutdiv: {
    paddingTop: '48px',
    paddingBottom: '48px',
    ['@media(max-width:576px)']: {
      paddingTop: '48px',
      paddingBottom: '48px',
    },
  },
  aboutname: {
    paddingRight: '8px',
    paddingLeft: '8px',
    ['@media(max-width:576px)']: {
      paddingRight: '0px',
      paddingLeft: '0px',
    },
  },
  bigdesc: {
    margin: '16px 8px 16px 16px',
  },
  dispnone: {
    display: 'none',
  },
});
function AboutSection({ selectedLang }) {
  const { t } = useTranslation();
  const classes = useStyles();
  SwiperCore.use([Autoplay, Pagination]);
  const [windowWidth, setWindowWidth] = useState(0);
  const [flip, setFlip] = useState(false);
  // const [play, setPlay] = useState(true);
  const { width } = useWindowDimensions();

  let items = 1;
  // let itemsMargin = 30;

  let resizeWindow = () => {
    setWindowWidth(window.innerWidth);
  };
  useEffect(() => {
    resizeWindow();
    window.addEventListener('resize', resizeWindow);
    return () => window.removeEventListener('resize', resizeWindow);
  }, []);
  useEffect(() => {
    const cap1 = document.querySelectorAll('.cap1');
    const cap2 = document.querySelectorAll('.cap2');
    if (width >= 1281) {
      for (let i = 0; i < cap1.length; i++) {
        cap1[i].style.display = 'block';
        cap2[i].style.display = 'none';
      }
    } else {
      for (let i = 0; i < cap1.length; i++) {
        cap1[i].style.display = 'none';
        cap2[i].style.display = 'block';
      }
    }
  }, [width]);
  if (windowWidth > 500) {
    items = 2;
  }
  if (windowWidth > 992) {
    items = 3;
  }
  if (windowWidth > 2000) {
    items = 4;
  }

  const handleFlip = (num) => {
    // if (!flip) slickCarousel.current.slickPause();
    // else slickCarousel.current.slickPlay();
    document.querySelector(`.card__inner${num}`).classList.toggle('is-flipped');
    if (!flip)
      setTimeout(() => {
        setFlip((fl) => !fl);
      }, 500);
    else setFlip(false);
  };
  //lang change
  let AboutData;
  if (selectedLang === 'en') {
    AboutData = AboutDataEN;
  } else if (selectedLang === 'fr') {
    AboutData = AboutDataFr;
  }
  //end of lang change
  const reset = () => {
    for (let i = 0; i < AboutData.length; i++) {
      document
        .querySelector(`.card__inner${AboutData[i].id}`)
        .classList.remove('is-flipped');
    }
    setFlip(false);
  };

  return (
    <>
      <div className="aboutSectionContainer" id="aboutSection">
        <Container fixed className={classes.aboutdiv}>
          <div className={`section-title ${classes.aboutname}`}>
            <h2>{t('sections-AboutSection-title')}</h2>
            <p>{t('sections-AboutSection-titleDesc')}</p>
          </div>

          {/* <p className=" px-3 px-sm-0 mt-3">{AboutText.desc}</p> */}
        </Container>
        <div className="caption cap2">{t('sections-AboutSection-caption')}</div>
        <div className={`cap2 script-box ${classes.bigdesc}`}>
          <div className="script  cap2" style={{ paddingRight: '4px' }}></div>
          {t('sections-AboutSection-fullDesc')}
          <p className="name">Head, Communications</p>
          <p className="desig">Aditya BN & Co</p>
        </div>
        <Grid align="center" justify="center" style={{ display: 'flex' }}>
          <Grid items xs={12} md={6} lg={`${width >= 2254 ? '3' : '4'}`}>
            <Swiper
              slidesPerView={1}
              direction="horizontal"
              centeredSlides
              onSlideChange={reset}
              pagination={{ dynamicBullets: true, clickable: true }}
              //spaceBetween={500}
            >
              {AboutData.map((data, index) => (
                <SwiperSlide>
                  <div className="card item" key={index}>
                    <div className={`card__inner${data.id} cover-card`}>
                      <div
                        className={`card__face card__face--front card${data.id}`}
                      >
                        <img src={data.image} alt="" />

                        <div
                          className="flip-icon-aboutus-front"
                          onClick={() => handleFlip(data.id)}
                        >
                          <FlipCameraAndroidIcon width="30px" height="30px" />
                        </div>
                        <div
                          className={`details ${flip ? classes.dispnone : ''}`}
                        >
                          <div
                            className={`name-1 ${flip ? classes.dispnone : ''}`}
                          >
                            {data.name}
                          </div>
                          <div
                            className={`desig-1 ${
                              flip ? classes.dispnone : ''
                            }`}
                          >
                            {data.field}
                          </div>
                        </div>
                      </div>
                      <div
                        className="card__face card__face--back"
                        style={{ background: `url(${data.image})` }}
                      >
                        <div
                          style={{
                            // backgroundImage: `url('${data.image}')`,
                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                            backgroundBlendMode: 'lighten',
                            backgroundRepeat: 'cover',
                          }}
                        >
                          <div className="card__face--content">
                            <p>{data.biography}</p>
                          </div>
                          <div
                            className="flip-icon-aboutus-back"
                            onClick={() => handleFlip(data.id)}
                          >
                            <FlipCameraAndroidIcon width="30px" height="30px" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>
          <Grid items xs={12} md={7}>
            <div className="caption cap1">
              {t('sections-AboutSection-caption')}
            </div>
            <div className="script-box cap1">
              <div className="script">
                {t('sections-AboutSection-fullDesc')}
              </div>
              <div className="name">{t('sections-AboutSection-headname')}</div>
              <div className="desig">{t('sections-AboutSection-compName')}</div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default AboutSection;
